<div class="container  border border-success rounded mt-2">
    <div class="alert " role="alert" *ngIf="cargandoFase" class="alert-success">
        <h4 class="alert-heading">Validando información</h4>
        <hr>
        <p class="mb-0">Se está validando la información para determinar si tiene que realizar pagos o continuar
            directamente a su comprobante de matrícula.</p>
        <app-progress *ngIf="cargandoFase"></app-progress>
    </div>
    <div class="alert alert-info fade show alert-dismissible" role="alert" *ngIf="validandopago">
        <strong><i class="fa fa-info-circle" aria-hidden="true"></i></strong> Validando pago
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="card border border-success mt-3" *ngIf="!cargandoFase || validandopago">
        <h5 class="card-header">Pago
            <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#CON" role="button"
                aria-expanded="true" aria-controls="CON"></a>
        </h5>
        <div class="collapse show" id="CON">
            <div class="card-body">

                <div class="alert alert-info" role="alert">
                    <p class="text-left">Estimado Postulante:</p>
                    <p class="text-left">Este es el resumen del pago que realizarás por Webpay, favor revisa bien los
                        montos y si ves que necesitas realizar algún cambio o ajuste, presiona el botón “Cancelar
                        Proceso de Matrícula”, para iniciar un nuevo proceso y anular este.</p>
                </div>

                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Producto</th>
                            <th scope="col">SubTotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>{{Apagar?.Concepto1}}</td>
                            <td>{{Apagar?.Monto1}}</td>
                        </tr>
                        <tr>
                            <th scope="row">2</th>
                            <td>{{Apagar?.Concepto2}}</td>
                            <td>{{Apagar?.Monto2}}</td>
                        </tr>
                        <tr>
                            <th scope="row"></th>
                            <td colspan="1"></td>
                            <td>{{Apagar?.Total }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="form-row" *ngIf="!cargandoFase">
                    <button type="button" class="btn btn-secondary btn-sm col-6" [ngClass]="{'d-none': !pago}"
                        (click)='pago=false'>Volver</button>
                    <a *ngIf="faseActual === '6'" type="button" class="btn btn-secondary btn-sm col-6"
                        [ngClass]="{'d-none': pago}" (click)='openModal()'> Cancelar proceso de matricula</a>
                    <button type="button" *ngIf="faseActual === '6'" class="btn btn-primary btn-sm col-6 getpago"
                        (click)="getpago()" [ngClass]="{'d-none': pago}">Revisa y confirma los montos a pagar
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="confirmarMonto"></span>
                    </button>
                    <a href={{url}} type="button" *ngIf="faseActual === '6'" class="btn btn-success btn-sm col-6"
                        [ngClass]="{'d-none': !pago}">Pagar</a>
                </div>

            </div>
        </div>
    </div>

</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" id="modal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Proceso matricula</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-warning alert-dismissible fade show" role="alert">
                    <strong>Advertencia !</strong> Cancelacion de proceso de matricula.
                    <label>Se anulará el proceso vigente</label>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="progress mt-4" *ngIf="procesar">
                    <div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar"
                        style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <button class="btn btn-primary btn-block btn-sm mt-2" (click)='CancelarMatricula()'
                    [disabled]='procesar'>Confirmar</button>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>